// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ib-0";
export var fileList = "_ib-2";
export var removeFileButton = "_ib-1";